import { DashboardWidget } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { useMemo } from "react";

import { Avatar } from "~/components/avatar";

import { useAppPromotionMessageRender } from "./messages/app-promotion/hooks";
import { useUpdatePaymentMessageRender } from "./messages/update-payment/hooks";

export const HeaderAvatar: FunctionComponent = ({ ...props }) => {
  const { updatePaymentMessageRender } = useUpdatePaymentMessageRender();
  const { appPromotionMessageRender } = useAppPromotionMessageRender();
  const messageRenders = useMemo(
    () => [updatePaymentMessageRender, appPromotionMessageRender],
    [updatePaymentMessageRender, appPromotionMessageRender],
  );

  return (
    <DashboardWidget messageRenders={messageRenders} {...props}>
      <Avatar />
    </DashboardWidget>
  );
};
